import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../../../i18n/langs";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: window.localStorage.getItem("lang"),
  messages,
  silentTranslationWarn: true,
});

export const OPERATOR_GROUP = () => [
  {
    uiType: [1, 2],
    options: [
      {
        value: 1,
        label: i18n.t("message.operatorGroup.Contains"),
      },
      {
        value: 2,
        label: i18n.t("message.operatorGroup.DoesNotContains"),
      },
    ],
  },
  {
    uiType: [1, 2],
    options: [
      {
        value: 3,
        label: i18n.t("message.operatorGroup.StartsWith"),
      },
      {
        value: 4,
        label: i18n.t("message.operatorGroup.DoesNotStartsWith"),
      },
    ],
  },
  {
    uiType: [1, 2],
    options: [
      {
        value: 5,
        label: i18n.t("message.operatorGroup.Like"),
      },
      {
        value: 6,
        label: i18n.t("message.operatorGroup.NotLike"),
      },
    ],
  },
  {
    uiType: [1, 2, 7, 10],
    options: [
      {
        value: 7,
        label: i18n.t("message.operatorGroup.EqualTo"),
      },
      {
        value: 8,
        label: i18n.t("message.operatorGroup.NotEqualTo"),
      },
    ],
  },
  {
    uiType: [1, 2, 3, 4, 6, 7, 10],
    options: [
      {
        value: 9,
        label: i18n.t("message.operatorGroup.IsNull"),
      },
      {
        value: 10,
        label: i18n.t("message.operatorGroup.IsNotNull"),
      },
    ],
  },
  {
    uiType: [4],
    options: [
      {
        value: 11,
        label: i18n.t("message.operatorGroup.ContainsAny"),
      },
      // {
      //   value: 12,
      //   label: i18n.t("message.operatorGroup.ContainsAll"),
      // },

      {
        value: 13,
        label: i18n.t("message.operatorGroup.ContainsNone"),
      },
    ],
  },
  {
    uiType: [3],
    options: [
      {
        value: 14,
        label: i18n.t("message.operatorGroup.Between"),
      },
      {
        value: 15,
        label: i18n.t("message.operatorGroup.NotBetween"),
      },
    ],
  },
  {
    uiType: [6, 7, 10],
    options: [
      {
        value: 16,
        label: i18n.t("message.operatorGroup.Between_DM"),
      },
      {
        value: 17,
        label: i18n.t("message.operatorGroup.NotBetween_DM"),
      },
    ],
  },
  {
    uiType: [6, 7, 10],
    options: [
      {
        value: 18,
        label: i18n.t("message.operatorGroup.GreatThan"),
      },
      {
        value: 19,
        label: i18n.t("message.operatorGroup.GreatThanOrEqualTo"),
      },
    ],
  },
  {
    uiType: [6, 7, 10],
    options: [
      {
        value: 20,
        label: i18n.t("message.operatorGroup.LessThan"),
      },
      {
        value: 21,
        label: i18n.t("message.operatorGroup.LessThanOrEqualTo"),
      },
    ],
  },
];

export const OPERATOR_LIST = () => [
  {
    uiType: [1, 2],
    options: [
      {
        value: 1,
        label: i18n.t("message.operatorGroup.Contains"),
      },
      {
        value: 2,
        label: i18n.t("message.operatorGroup.DoesNotContains"),
      },
    ],
  },
  {
    uiType: [1, 2, 3, 4, 6, 7, 10],
    options: [
      {
        value: 9,
        label: i18n.t("message.operatorGroup.IsNull"),
      },
      {
        value: 10,
        label: i18n.t("message.operatorGroup.IsNotNull"),
      },
    ],
  },
];

export const SPECIAL_LIST = [
  1000006,
  1000002,
  1004002,
  1004003,
  1004008,
  1004009,
  1004010,
  1011002,
  1055001,
  1011003,
  1001241,
  1012003,
  1012005,
  1051010,
  1051011,
  1051020,
  1051009,
  1051019,
  1051031,
  1051071,
  4010005,
  4010004,
  4010011,
  2010005,
];
